import { z } from 'zod/v3';

export const ActionItemCategorySchema = z.enum([
  'remediation',
  'agent_escalation',
  'policy_approval',
  'consistency_gap',
  'evidence_expired',
  'scan_finding',
]);
export type ActionItemCategory = z.infer<typeof ActionItemCategorySchema>;

export const TaskStatusSchema = z.enum([
  'OPEN',
  'ASSIGNED',
  'IN_PROGRESS',
  'IN_REVIEW',
  'BLOCKED',
  'RESOLVED',
  'DISMISSED',
]);
export type TaskStatus = z.infer<typeof TaskStatusSchema>;

export const PrioritySchema = z.enum(['HIGH', 'MEDIUM', 'LOW']);
export type Priority = z.infer<typeof PrioritySchema>;

export const ActionItemAssigneeSchema = z.object({
  id: z.string(),
  name: z.string(),
  image: z.string().nullable().optional(),
});
export type ActionItemAssignee = z.infer<typeof ActionItemAssigneeSchema>;

export const ActionItemDTOSchema = z.object({
  id: z.string(),
  category: ActionItemCategorySchema,
  title: z.string(),
  description: z.string().optional(),
  severity: z.string(),
  controlRef: z.string().optional(),

  // Unified workflow (from source OR FeedbackSignal)
  taskStatus: TaskStatusSchema,
  assignedTo: ActionItemAssigneeSchema.optional(),
  assignedToId: z.string().optional(),
  dueDate: z.string().optional(), // ISO date string
  priority: PrioritySchema,

  // Signal reference (only for gap-fill types)
  signalId: z.string().optional(),

  // For remediation items — needed for lifecycle mutations
  findingKey: z.string().optional(),

  // Scan findings are read-only
  readOnly: z.boolean().optional(),

  // Type-specific metadata
  meta: z.record(z.unknown()),

  createdAt: z.string(), // ISO date string
});
export type ActionItemDTO = z.infer<typeof ActionItemDTOSchema>;

export const ActionItemCountsSchema = z.object({
  open: z.number(),
  inProgress: z.number(),
  overdue: z.number(),
  resolved: z.number(),
  byCategory: z.record(z.number()),
});
export type ActionItemCounts = z.infer<typeof ActionItemCountsSchema>;

export const ActionItemsResponseDTOSchema = z.object({
  items: z.array(ActionItemDTOSchema),
  counts: ActionItemCountsSchema,
});
export type ActionItemsResponseDTO = z.infer<typeof ActionItemsResponseDTOSchema>;
